// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XE4vAjYa9OhQl8nwiYMr {
  background: var(--top-block-contrast-background);
  border-radius: 0.5rem;
  max-width: 32.6875rem;
}

.E6kBvmzoTWmydT3qZxjw {
  color: var(--top-block-font-color);
  margin: 0.625rem 0.3125rem 0.625rem 0;
  font-size: 1rem;
  line-height: 1.375rem;
}

.XlyiDzwjjfaq5g3lnawp {
  margin: 0.625rem 0.3125rem 0 0.625rem;
  width: 1.875rem;
}

@media only screen and
  (min-width: 640px) and
  (max-width: 1023px) {
  .E6kBvmzoTWmydT3qZxjw {
    font-size: 1rem;
    line-height: 1.375rem;
  }
}

@media only screen and
  (max-width: 639px) {
  .E6kBvmzoTWmydT3qZxjw {
    font-size: 1rem;
    line-height: 1.375rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/HeroUsp/HeroUsp.module.css"],"names":[],"mappings":"AAAA;EACE,gDAAgD;EAChD,qBAAkB;EAClB,qBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,qCAAuB;EACvB,eAAe;EACf,qBAAiB;AACnB;;AAEA;EACE,qCAAuB;EACvB,eAAW;AACb;;AAEA;;;EACE;IACE,eAAe;IACf,qBAAiB;EACnB;AACF;;AAEA;;EACE;IACE,eAAe;IACf,qBAAiB;EACnB;AACF","sourcesContent":[".uspWrapper {\n  background: var(--top-block-contrast-background);\n  border-radius: 8px;\n  max-width: 523px;\n}\n\n.uspItem {\n  color: var(--top-block-font-color);\n  margin: 10px 5px 10px 0;\n  font-size: 16px;\n  line-height: 22px;\n}\n\n.uspItemIcon {\n  margin: 10px 5px 0 10px;\n  width: 30px;\n}\n\n@media (--tablet) {\n  .uspItem {\n    font-size: 16px;\n    line-height: 22px;\n  }\n}\n\n@media (--mobile) {\n  .uspItem {\n    font-size: 16px;\n    line-height: 22px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"uspWrapper": `XE4vAjYa9OhQl8nwiYMr`,
	"uspItem": `E6kBvmzoTWmydT3qZxjw`,
	"uspItemIcon": `XlyiDzwjjfaq5g3lnawp`
};
export default ___CSS_LOADER_EXPORT___;
